// extracted by mini-css-extract-plugin
export default {"title":"DialogTitle_title__R0U+-","close":"DialogTitle_close__cYDJx"};